<ng-container *ngIf="courseAreas.length > 0">
  <div id="course-areas" class="content-container">
    <div class="section text-block">
      <h1 class="heading">{{ locale.titleText }}</h1>
      <p
        class="normal"
        [innerHTML]="locale.subtitleText | stringFormat: [name] | parseFormattedText"
      ></p>
      <p
        class="info normal"
      >{{ locale.dcdInfoText }}</p>

      <!-- Badge keys -->
      <div class="badge-keys">
        <p class="normal">
          <span class="course-badge initial-interest-badge">
            {{ locale.initialInterestBadge }}
          </span> {{ locale.initialInterestBadgeDesc }}
        </p>
        <p class="normal">
          <span class="course-badge high-match-badge">
            {{ locale.highMatchBadge }}
          </span> {{ locale.highMatchBadgeDesc }}
        </p>
      </div>
    </div>

    <div
      class="section"
      data-step="1"
      [attr.data-intro]="locale.overlayIntro"
      data-scrollTo="tooltip"
    >
      <!-- Filters -->
      <div
        class="section text-block applied-filters"
        [ngClass]="{ 'hide-filters': numberOfSelectedCourses == 0 }"
      >
        <ul class="cf">
          <ng-container *ngFor="let courseArea of courseAreas">
            <ng-container *ngIf="courseArea.selected == true">
              <li [@fadeInOutShrink]>
                <div class="filter">
                  <span class="filter-title">{{ courseArea.title }}</span>
                  <a class="remove" (click)="toggleCourse(courseArea)"
                    >locale.removeFilterButtonText</a
                  >
                </div>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>

      <div class="section text-block">
        <ng-container *ngTemplateOutlet="courseAreaHeaderLine"></ng-container>
        <ng-container *ngFor="let courseArea of (courseAreas | courseAreaFilter: filterText:true)">
          <ng-container
            *ngTemplateOutlet="
              courseAreaLine;
              context: { courseArea: courseArea, smallIcon: false }
            "
          >
          </ng-container>
        </ng-container>
      </div>

      <div class="section text-block">
        <h1 class="heading">{{ locale.otherCourseHeaderText }}</h1>
        <p class="normal">{{ locale.otherCourseSubText }}</p>
      </div>

      <div class="section text-block">
        <ng-container *ngTemplateOutlet="courseAreaHeaderLine"></ng-container>
        <ng-container *ngFor="let courseArea of (courseAreas | courseAreaFilter: filterText:false)">
          <ng-container
            *ngTemplateOutlet="courseAreaLine; context: { courseArea: courseArea, smallIcon: true }"
          >
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-template #courseAreaHeaderLine>
    <div class="columnar mobile-hide">
      <div class="course-area">&nbsp;</div>
      <div class="interest-level">
        <p>
          {{ locale.interestLabelText }}<br />
          <i>{{ locale.interestLabelSubText }}</i>
        </p>
      </div>
      <div class="overall-match">
        <p>
          {{ locale.matchLabelText }}<br />
          <i>{{ locale.matchLabelSubText }}</i>
        </p>
      </div>
      <div class="course-view">
        <p class="course-areas-header">{{ locale.matchLabelView }}</p>
      </div>
      <div class="course-select">
        <p class="course-areas-header">{{ locale.matchLabelSelect }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template #courseAreaLine let-courseArea="courseArea" let-smallIcon="smallIcon">
    <div (click)="viewCourseArea(courseArea.id)" class="columnar course-area-row">
      <div class="course-area">
        <span [ngClass]="{ 'ball-small': smallIcon, ball: !smallIcon }">{{
          courseArea.ordinal
        }}</span>
        <p class="course-title top-title" [attr.data-intro]="locale.overlayArrow">
          {{ courseArea.title }}
          <span class="course-badge high-match-badge" *ngIf="courseArea.highMatch">
            {{ locale.highMatchBadge }}
          </span>
          <span class="course-badge initial-interest-badge" *ngIf="courseArea.initialInterest">
            {{ locale.initialInterestBadge }}
          </span>
        </p>
        <btn-dropdown
          *ngIf="dcdsLoaded"
          listTitle="DCD"
          (clickedDropdown)="clickedDropdown($event)"
          (clickedItem)="clickedItem($event)"
          (click)="$event.stopPropagation();"
          image="assets/images/MFC-Logo-Greyscale.png"
          [parentId]="courseArea.id"
          [items]="relatedDcds[courseArea.id].articles ? relatedDcds[courseArea.id].articles : []"
          [isLoading]="!loadedAreaArticles.includes(courseArea.id)"
          [events]="dropdownClickedSubject.asObservable()"
        ></btn-dropdown>
      </div>
      <div class="interest-level tooltip">
        <div class="rating">
          <i>{{ locale.interestLabelText }}</i>
          <div class="rating-bar">
            <rating-bar [percentage]="courseArea.interest"></rating-bar>
          </div>
        </div>
        <span class="tooltip-text">{{
          locale.interestTooltipText | stringFormat: [courseArea.title, courseArea.interest]
        }}</span>
      </div>
      <div class="overall-match tooltip">
        <div class="rating">
          <i>{{ locale.matchLabelText }}</i>
          <div class="rating-bar">
            <rating-bar [percentage]="courseArea.match"></rating-bar>
          </div>
        </div>
        <span class="tooltip-text">{{
          locale.matchTooltipText | stringFormat: [courseArea.title, courseArea.match]
        }}</span>
      </div>
      <div class="course-view">
        <span class="mobile-only">
          <button
            class="view-button"
            (click)="viewCourseArea(courseArea.id)"
            [attr.data-intro]="locale.overlayArrow"
          >
            {{ locale.matchLabelView }}
          </button>
        </span>
        <span class="mobile-hide tooltip">
          <a
            (click)="viewCourseArea(courseArea.id)"
            class="view-icon"
            [attr.data-intro]="locale.overlayArrow"
            >({{ locale.viewText }})</a
          >
          <span class="tooltip-text">{{ locale.viewAreaToolTip }}</span>
        </span>
      </div>
      <div class="course-select">
        <span class="mobile-only">
          <button
            class="compare-button"
            (click)="$event.preventDefault(); $event.stopPropagation(); toggleCourse(courseArea)"
            [ngClass]="{ selected: courseArea.selected, 'disable-hover': disableHover }"
          >
            {{ locale.matchLabelSelect }}
          </button>
        </span>
        <span class="mobile-hide tooltip">
          <app-tick-button
            (click)="$event.preventDefault(); $event.stopPropagation(); toggleCourse(courseArea)"
            [disableClick]="disableClick"
            [selected]="courseArea.selected"
            data-step="3"
            [attr.data-intro]="locale.overlayTick"
            >{{ locale.selectCoursesButtonText }}</app-tick-button
          >
          <span class="tooltip-text" *ngIf="courseArea.selected">{{
            locale.deselectAreaToolTip
          }}</span>
          <span class="tooltip-text" *ngIf="!courseArea.selected">{{
            locale.selectAreaToolTip
          }}</span>
        </span>
      </div>
    </div>
  </ng-template>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/components/course-areas/list/course-area-list/course-area-list.component.html